import React from 'react';
import { Button } from '../ui/Button';

export const TemplateCard = ({ id, name, description, image, onSelect }) => {
  return (
    <div className="group relative bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200 overflow-hidden flex flex-col h-full">
      <div className="aspect-[3/4] bg-gray-100 relative overflow-hidden">
        {image ? (
          <img src={image} alt={name} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-400 bg-gray-50">
            <span className="text-sm">Preview</span>
          </div>
        )}
        
        {/* Overlay on hover */}
        <div className="absolute inset-0 bg-blue-900/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center backdrop-blur-sm">
          <Button onClick={() => onSelect(id)} size="lg" className="shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
            Use This Template
          </Button>
        </div>
      </div>
      
      <div className="p-5 flex-1 flex flex-col">
        <h3 className="text-lg font-bold text-gray-900 mb-1">{name}</h3>
        <p className="text-sm text-gray-500 mb-4 flex-1">{description}</p>
      </div>
    </div>
  );
};
